import React from 'react';

import ContratosGerenciamento from '../views/ContratosGerenciamento';
import ContratosTransferencia from '../views/ContratosTransferencia';
import ContratosVincular from '../views/ContratosVincular';
import ContratosTodos from '../views/ContratosTodos';

export default class Contratos extends React.Component {
  render () {
    switch (this.props.match.params.caminho) {
      case "novo":
        return <ContratosGerenciamento/>;
      case "transferir":
        return <ContratosTransferencia/>;
      case "vincular":
        return <ContratosVincular/>;
      case "pesquisar":
        return <ContratosTodos/>;
      default:
        return <ContratosGerenciamento/>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Contratos.js